import { Space, Tooltip, Typography } from "antd"
import VSpace from "../common/VSpace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons"
import { useWonLost } from "./dashboardQueries"
import { DashboardFilters, hasDashboardFilters } from "./dashboardModel"
import { GraphingData } from "./dashboardApi"
import PieChart from "../Charts/PieChart"
import dayjs from "dayjs"
import ExportCsvButton from "../Datacenter/ExportCsvButton"
import useDashboardReporting from "../../hooks/useDashboardReporting"
import { chartExportColumns, chartExportRows, dashboardReportName } from "./dashboardExport"

export type Props = {
  start: string
  end: string
  // The end sent to the API, when it differs from the date shown.
  queryEnd?: string
  // dashboard-reporting only; without it the card loads exactly as before.
  filters?: DashboardFilters
}

const WonLostGraph = ({start, end, queryEnd = end, filters}: Props) => {
  const query = useWonLost(start, queryEnd, filters)
  const dashboardReporting = useDashboardReporting()
  const hasDate = !!start && !!end

  const createDataset = (data: GraphingData | undefined) => {
    if(!data){
      return []
    }

    const dataset: any = []
    data.labels.forEach(function (value, i) {
      dataset.push({type: value,value:data.datasets[0][i]})
    });

    return dataset
  }

  return <div style={{ width: '440px'}}>
    <VSpace style={{minWidth: '440px', textAlign: 'center', width: '440px'}}>
      <Space>
        <h1 style={{font: '1.4em "Proza Libre'}}>WON / LOST</h1>
        <Tooltip title="By Category">
          <FontAwesomeIcon icon={faCircleInfo} />
        </Tooltip>
      </Space>
      { hasDate 
        ? <div>From {start} to {end}</div>
        : <div>Please select a time range at the top of the page.</div>
      }
      {filters && hasDashboardFilters(filters) && <Typography.Text type="secondary">Filtered by the report filters</Typography.Text>}
      {dashboardReporting && hasDate && <div><ExportCsvButton size="small" reportName={dashboardReportName('Won Lost', filters)} dateRange={{ start: dayjs(start), end: dayjs(end) }} columns={chartExportColumns('Jobs')} rows={chartExportRows(query.data)} /></div>}
      <div style={{fontSize: '20pt', marginTop: '10px'}}></div>
      { query.isLoading 
        ? <span>Loading...</span> 
        : query.isError
          ? <span>Error loading data</span>
          : <PieChart data={createDataset(query.data ?? undefined)} />
      }
    </VSpace>
  </div>
}

export default WonLostGraph